if ((typeof Shopify) === 'undefined') { window.Shopify = {} }
if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function (callback, cart) {
    if (!cart) {
      return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
          callback(cart, textStatus, xhr)
        } else {
          Shopify.onCartUpdate(cart)
        }
      })
    } else {
      if ((typeof callback) === 'function') {
        callback(cart)
      } else if (typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate(cart)
      }
    }
  }
}

class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      console.log("event", event.target, event.target.closest('.parrent'))
      const dataJson = this.dataset.layer ? JSON.parse(this.dataset.layer) : {}
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0)
      trigger('removeFromCart', document, { product: dataJson })
    })
  }
}

customElements.define('cart-remove-button', CartDrawerRemoveButton)

class CartDrawerAddSample extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      this.setAttribute('disabled', true)
      this.classList.add('loading')
      const dataJson = this.dataset.layer ? JSON.parse(this.dataset.layer) : {}
      trigger('productAddToCart', document, { product: dataJson, list: 'Mini Cart - Samples' })
      const id = this.dataset.sampleId
      const body = JSON.stringify({
        items: [{
          id: id,
          quantity: 1
        }],
        sections: atcGetSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          atcGetSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)

            elementToReplace.innerHTML =
              getSectionInnerHTML(parsedState.sections[section.section], section.selector)

            var api = new Yotpo.API(yotpo)
            api.refreshWidgets()
            MicroModal.init()

          }))
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.classList.remove('loading')
          this.removeAttribute('disabled')
        })
    })
  }
}

customElements.define('cart-drawer-add-sample', CartDrawerAddSample)

class CartDrawerRemoveSample extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      const dataJson = this.dataset.layer ? JSON.parse(this.dataset.layer) : {}
      trigger('removeFromCart', document, { product: dataJson })

      this.setAttribute('disabled', true)
      this.classList.add('loading')

      const id = this.dataset.sampleId

      const body = JSON.stringify({
        id: id,
        quantity: 0,
        sections: atcGetSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      })


      fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), ...{ body } })
        .then((response) => response.json())
        .then((parsedState) => {
          atcGetSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)

            elementToReplace.innerHTML =
              getSectionInnerHTML(parsedState.sections[section.section], section.selector)

            var api = new Yotpo.API(yotpo)
            api.refreshWidgets()
            MicroModal.init()

          }))
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.classList.remove('loading')
          this.removeAttribute('disabled')
        })
    })
  }
}

customElements.define('cart-drawer-remove-sample', CartDrawerRemoveSample)

class CartDrawer extends HTMLElement {
  constructor() {
    super()

    // Elements
    this.drawer = document.getElementById('cart-drawer')
    this.drawerContent = this.drawer.querySelector('#cart-drawer__content')

    this.cartButton = document.querySelector('.js-open-cart')
    this.cartButton.addEventListener('click', this.handleCartClick.bind(this))

    this.closeIcon = document.getElementById('cart-drawer__close')
    this.closeIcon.addEventListener('click', this.close.bind(this))

    this.closeButton = document.getElementById('cart-drawer__close-footer')
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this))
    }

    this.onBodyClick = this.handleBodyClick.bind(this)
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())

    this.pageOverlayElement = document.querySelector('.page-overlay')

    if (this.drawer.querySelector('[data-micromodal-trigger]')) {
      this.drawer.querySelector('[data-micromodal-trigger]').addEventListener("click", function (evt) {
        evt.preventDefault()
        evt.stopPropagation()
      })
    }

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))

    this.drawerContent.style.maxHeight = window.innerHeight + 'px'
    window.addEventListener('resize', () => {
      this.drawerContent.style.maxHeight = window.innerHeight + 'px'
    })
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false)
    this.drawer.setAttribute('aria-expanded', true)

    this.pageOverlayElement.classList.add('is-visible')
    document.body.addEventListener('click', this.onBodyClick)
    document.documentElement.style.overflow = 'hidden'
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true)
    this.drawer.removeAttribute('aria-expanded', true)

    this.pageOverlayElement.classList.remove('is-visible')
    document.body.removeEventListener('click', this.onBodyClick)
    document.body.style.overflow = 'visible';
    document.documentElement.style.overflow = 'visible'
  }

  onChange(event) {
    if (event.target.dataset.index) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
    }
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    })

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        // after change to cart is made, compare the total to the threshold
        // if total is not under threshold, return
        if (parsedState.total_price >= Number(this.dataset.threshold)) return JSON.stringify(parsedState)

        //if total is under threshold, check for sample products
        let sampleProducts = parsedState.items.map((item) => {
          if (item.product_type == 'Sample') return item.id
        })
        let sampleIds = sampleProducts.filter((id) => {
          return id != undefined
        })

        // if not sample products in cart, return
        if (sampleIds.length == 0) return JSON.stringify(parsedState)

        // if sample products in cart, format IDs for updating the cart
        let update_data = {}
        sampleIds.forEach((id) => {
          update_data[id] = 0
        })

        // update cart
        const body = JSON.stringify({
          updates: update_data,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        })

        return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text()
          })
      })
      .then((parsedState) => {
        return Shopify.getCart(function (cart) {
          if (name === 'plus') {
            trigger('productAddToCart', document, { product: parsedState, list: 'Mini Cart - Items' })
          } else if (name === 'minus') {
            trigger('removeFromCart', document, { product: parsedState, quantity: 1 })
          }
        }.bind(this))
      })
      .then((state) => {
        return fetch("/?sections=cart-drawer,cart-icon-bubble")
          .then((response) => { return response.json() })
          .then((responseText) => {
            const html = responseText
            const replaceDrawer =
              document.getElementById('cart-drawer__content').querySelector('cart-drawer__content') || document.getElementById('cart-drawer__content')
            const replaceBubble =
              document.getElementById('cart-icon-bubble').querySelector('.shopify-section') || document.getElementById('cart-icon-bubble')

            replaceDrawer.innerHTML =
              getSectionInnerHTML(html['cart-drawer'], '.cart-drawer__content')
            replaceBubble.innerHTML =
              getSectionInnerHTML(html['cart-icon-bubble'], '.shopify-section')

            var api = new Yotpo.API(yotpo)
            api.refreshWidgets()
            MicroModal.init()
          })
      })
      .catch(() => {
        this.disableLoading()
      })
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
    ]
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading() {
    document.getElementById('cart-drawer-loading').classList.remove('hidden')
  }

  disableLoading() {
    if (document.getElementById('cart-drawer-loading')) {
      document.getElementById('cart-drawer-loading').classList.add('hidden')
    }
  }

  handleBodyClick(evt) {
    const target = evt.target
    if (target.classList.contains('page-overlay') || target.hasAttribute("data-cart-close")) {
      this.close()
      this.pageOverlayElement.classList.remove('is-visible')
    } else if (target.getAttribute('name') == 'checkout') {
      target.setAttribute('disabled', true)
      target.classList.add('loading')
      if (target.dataset.hasSubscriptions == "true") {
        this.getSubscriptionData(evt)
      }
    }
  }

  getSubscriptionData(evt) {
    var disable_recharge = evt.target.getAttribute('data-disable-recharge')

    const rechargeData = document.querySelector('recharge-data')
    if (!rechargeData) return

    const cart_options = JSON.parse(rechargeData.getAttribute("cart_options"))
    const customer = JSON.parse(rechargeData.getAttribute("customer"))
    const cart = JSON.parse(rechargeData.getAttribute("cart"))
    // const subscriptions = JSON.parse(rechargeData.getAttribute("subscriptions"))

    if (cart_options && !cart_options.disable && (!disable_recharge || disable_recharge !== 'true')) {
      evt.preventDefault()
      cartSubmit(cart_options, customer, cart)
    } else {
      window.console.log('ReCharge was disabled intentionally.')
    }
    // restoreCheckoutButton();
    target.classList.remove('loading')
    target.removeAttribute('disabled')
  }

  handleCartClick(evt) {
    evt.preventDefault()
    this.open()
  }

  reChargeProcessCart(evt) {
    evt.preventDefault()
    function get_cookie(name) { return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2] }
    do {
      token = get_cookie('cart')
    }
    while (token == undefined); var myshopify_domain = '{{ shop.permanent_domain }}'
    try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch (err) { var ga_linker = '' }
    checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker
  }
}

customElements.define('cart-drawer', CartDrawer)

class SubscriptionUpdate extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onSubscriptionChange)

    const subscription_update_button = this.querySelector(`[data-subscribe-button]`)
    subscription_update_button.addEventListener("click", function (evt) {
      console.log('update subscription');
      evt.preventDefault()
      evt.stopPropagation()

      this.setAttribute('disabled', true)
      this.classList.add('loading')

      CartDrawer.enableLoading
      if (evt.target.dataset.newSubscription != evt.target.dataset.currentSubscription) {

        const attributes = (evt.target.dataset.newValue == "") ? JSON.parse(this.closest("subscription-update").querySelector(`input[name='${evt.target.dataset.currentSubscription}-subscription-frequency']:checked`).value) : JSON.parse(evt.target.dataset.newValue);
        let selling_plan = attributes.selling_plan && attributes.selling_plan;
        // remove product
        let remove_sub = JSON.stringify({
          id: subscription_update_button.dataset.currentSubscription,
          quantity: 0,
        })

        // add new product
        let add_sub = JSON.stringify({
          items: [{
            id: Number(attributes.id),
            quantity: 1,
            ...(selling_plan && { selling_plan: Number(selling_plan) })
          }],
          sections: atcGetSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        })

        fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript'), ...{ body: remove_sub } })
          .then((response) => response.json())
          .then((data) => {
            return fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body: add_sub })
          })
          .then((response) => response.json())
          .then((parsedState) => {
            return Shopify.getCart(function (cart) {
              trigger('productAddToCart', document, { product: parsedState, list: 'Mini Cart - Recommended Products' })
            }.bind(this))
          })
          .then((state) => {
            return fetch("/?sections=cart-drawer,cart-icon-bubble")
              .then((response) => { return response.json() })
              .then((responseText) => {
                const html = responseText
                const replaceDrawer =
                  document.getElementById('cart-drawer__content').querySelector('cart-drawer__content') || document.getElementById('cart-drawer__content')
                const replaceBubble =
                  document.getElementById('cart-icon-bubble').querySelector('.shopify-section') || document.getElementById('cart-icon-bubble')

                replaceDrawer.innerHTML =
                  getSectionInnerHTML(html['cart-drawer'], '.cart-drawer__content')
                replaceBubble.innerHTML =
                  getSectionInnerHTML(html['cart-icon-bubble'], '.shopify-section')

                var api = new Yotpo.API(yotpo)
                api.refreshWidgets()
                MicroModal.init()
              })
          })
          .catch((e) => {
            console.error(e)
            CartDrawer.disableLoading
          })
          .finally(() => {
            this.classList.remove('loading')
            this.removeAttribute('disabled')
            MicroModal.close(this.closest('.modal').getAttribute("id"))
            if (document.querySelector('[data-cart-drawer-overlay]')) {
              document.querySelector('[data-cart-drawer-overlay]').style.display = "none"
            }
          })
      }
    })
  }

  onSubscriptionChange(event){
    console.log('changed cart-drawer');
    event.stopPropagation();
    const attributes = JSON.parse(event.target.value);
    const formID = event.target.getAttribute('form');
    
    if(this.querySelector("label[data-product-id].is-active")){
      this.querySelector("label[data-product-id].is-active").classList.remove("is-active");
      event.target.closest("label[data-product-id]").classList.add("is-active");
    }

    // Update Notice
    const form_notice = document.querySelector(`.subscription-product-form__notice[product_form_id="${formID}"]`)
    if (form_notice){
      const data_three_month = form_notice.getAttribute('data-three-month')
      const data_three_month_content = form_notice.getAttribute('data-three-month-content')
      const data_six_month = form_notice.getAttribute('data-six-month')
      const data_six_month_content = form_notice.getAttribute('data-six-month-content')
      let noticeContent = form_notice.querySelector("[data-notice-content]");
      if (attributes.id == data_three_month) {
        form_notice.style.display = "flex"
        noticeContent.innerHTML = data_three_month_content
      } else if (attributes.id == data_six_month) {
        form_notice.style.display = "flex"
        noticeContent.innerHTML = data_six_month_content
      } else {
        form_notice.style.display = "none"
        noticeContent.innerHTML = ''
      }
    }
  
    // update subscribe buttons
    const subscription_update_button = this.querySelector(`[data-subscribe-button]`)
    if( !subscription_update_button ) return;
    subscription_update_button.querySelector('[data-button-title]').innerHTML = attributes.button_title
    subscription_update_button.querySelector('[data-product-price]').innerText = attributes.price
    subscription_update_button.setAttribute("data-new-subscription", attributes.id)
    subscription_update_button.setAttribute("data-new-value", event.target.value)

    }
}
customElements.define('subscription-update', SubscriptionUpdate)

class SubscriptionModalTrigger extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", function (evt) {
      evt.preventDefault()
      evt.stopPropagation()
      MicroModal.show(this.dataset.micromodalTrigger)

      // check if subscribe button clicked is inside recommended products (need to update z-index of reco products sec)
      if (document.querySelector('.cart-drawer__recommended-products').contains(this)) {
        document.querySelector('.cart-drawer__recommended-products').style.zIndex = "10";
        document.querySelector('.cart-drawer__recommended-products').style.padding = '0px'
      } else if (document.querySelector('.cart-drawer__form').contains(this)) {
        // document.querySelector('.cart-drawer__form').style.zIndex = "10";
      }
      if (document.querySelector('[data-cart-drawer-overlay]')) {
        document.querySelector('[data-cart-drawer-overlay]').style.display = "block"
      }
    })
  }
}

customElements.define('subscription-modal-trigger', SubscriptionModalTrigger)

class CartNote extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('change', debounce((event) => {
      event.stopPropagation()
      const body = JSON.stringify({ note: event.target.value })
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    }, 300))
  }
}

customElements.define('cart-note', CartNote)

class CartNoteTrigger extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', debounce((event) => {
      if (this.classList.contains('active')) {
        this.classList.remove('active')
        slideUp(this.nextElementSibling, 350)
      } else {
        this.classList.add('active')
        slideDown(this.nextElementSibling, 350)
      }
    }, 300))
  }
}

customElements.define('cart-note-trigger', CartNoteTrigger)

// RECHARGE SCRIPTS
if (!window.ReCharge) { window.ReCharge = {} }

class RechargeData extends HTMLElement {
  constructor() {
    super()
  }
}
customElements.define('recharge-data', RechargeData)


function createDelegatedEventListener(selector, handler) {
  return (event) => {
    if (event.target.matches(selector) || event.target.closest(selector)) {
      handler(event)
    }
  }
}
function get_cart_token() {
  // Build the cart_token param for the URL generator
  try {
    return ['cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2]]
  } catch (e) {
    return []
  }
}
function get_ga_linker() {
  // Build the ga_linker param for the URL generator
  try {
    return [ga.getAll()[0].get('linkerParam')]
  } catch (e) {
    return []
  }
}
function buildCustomerObject(email_address, address_object) {
  // Return a data object with the customer shipping address
  var data = {
    email: email_address
  }
  try {
    return Object.assign(data, address_object)
  } catch (e) {
    return data
  }
}
function getCartJSON(options) {
  // Fetch the latest cart data from the /cart.js endpoint
  if (options && !options.cartjson) return {}
  return fetch('/cart.js')
    .then(function (response) {
      return response.json()
    })
    .then(function (json) {
      return ({ cart: JSON.stringify(json) })
    })
    .catch(function (error) {
      console.error('Error retreiving cart: ', error)
      return ({ cart: JSON.stringify(cart) })
    })
}
function restoreCheckoutButton() {
  // Reverse embedded CSS that hides the submit button
  // This is done to discourage the chance a user hits "Checkout" before the page is done loading
  var cart_buttons = document.querySelectorAll('form[action^="/cart"] [type="submit"]'),
    buttons_to_update = Array.prototype.slice.apply(cart_buttons)
  buttons_to_update.forEach(function (elem) {
    elem.style.visibility = 'visible'
  })
}
function updateProductUrls(items) {
  // Map hidden product handles back to their original product handle
  Object.keys(items).forEach(function (id) {
    var product = items[id],
      product_url = product['url'],
      product_handle = product['original_handle'],
      product_links = document.querySelectorAll('a[href*="' + product_url + '"]')
    var links_to_update = Array.prototype.slice.apply(product_links)
    links_to_update.forEach(function (link) {
      link.setAttribute('href', '/products/' + product_handle)
    })
  })
}
function buildCheckoutUrl(options) {
  // Build the Checkout URL
  var checkout_url = 'https://' + options.checkout_domain + '/r/checkout?',
    url_params = [
      'myshopify_domain=' + options.permanent_domain,
    ]
  url_params = url_params
    .concat(get_cart_token())
    .concat(get_ga_linker())
  return checkout_url + url_params.join('&')
}
function filterVisible(elems) {
  // Return visible elements
  return elems.filter(function (elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)
  })
}
function filterValues(elems) {
  // Return inputs with valid values
  return elems.filter(function (elem) {
    var is_active_checkbox = elem.getAttribute('type') === 'radio' && elem.checked,
      is_active_radio = elem.getAttribute('type') === 'checkbox' && elem.checked,
      is_input = elem.getAttribute('type') !== 'checkbox' && elem.getAttribute('type') !== 'radio'
    return !!elem.value && (is_input || is_active_checkbox || is_active_radio)
  })
}
function getTermsAndConditions() {
  // Find and return concacted terms and conditions values
  var condition_selectors = [
    '#terms',
    '#agree',
  ],
    conditions = document.querySelectorAll(condition_selectors.join(',')),
    conditions_to_update = Array.prototype.slice.apply(conditions),
    conditions_filtered = filterValues(conditions_to_update),
    condition_values = conditions_filtered.map(function (elem) {
      return elem.value
    })
  if (!condition_values.length) { return {} }
  return {
    terms_and_conditions: condition_values.join(', ')
  }
}
function getNotes(cart) {
  // Find and return concatenated note values if visible
  var note_selectors = [
    '[name="note"]',
  ],
    notes = document.querySelectorAll(note_selectors.join(',')),
    notes_to_update = Array.prototype.slice.apply(notes),
    notes_filtered = filterVisible(notes_to_update),
    note_values = notes_filtered.map(function (elem) { return elem.value })
  var urlParams = new URLSearchParams(decodeURIComponent(window.location.search)),
    noteFromUrl = urlParams.get('note')
  if (cart.note) {
    note_values.push(cart.note)
  }
  if (noteFromUrl) {
    note_values.push(noteFromUrl)
  }
  if (!note_values.length) return ''
  var uniqueNoteValues = note_values.filter(function (element, index, array) {
    return array.indexOf(element) === index
  })
  return { note: uniqueNoteValues.join(', ') }
}
function getAttributes() {
  // Find and return cart attributes
  var attributeRegEx = /attributes\[(.*?)\]/,
    attributeNameRegex = /\[(.*?)\]/,
    attribute_selectors = [
      '[name*="attributes"]',
    ],
    attributes = document.querySelectorAll(attribute_selectors.join(',')),
    attributes_to_update = Array.prototype.slice.apply(attributes),
    attributes_filtered = filterValues(attributes_to_update)
  var attribute_data = {},
    utm_attributes = getUTMAttributes(),
    attributes_from_url = new URLSearchParams(decodeURIComponent(window.location.search))
  for (let pair of attributes_from_url) {
    if (attributeRegEx.test(pair[0])) {
      var attributeName = pair[0]
        .match(attributeNameRegex)[0]
      attributeName = attributeName.substring(1, attributeName.length - 1)
      attribute_data[attributeName] = attributes_from_url.get(pair[0])
    }
  }
  attributes_filtered.forEach(function (attribute) {
    var name = attribute.getAttribute('name'),
      value = attribute.value
    if (attributeRegEx.test(name)) {
      var extractedName = name.match(attributeNameRegex)[0]
      extractedName = extractedName.substring(1, extractedName.length - 1)
      return attribute_data[extractedName] = value
    }
    return attribute_data[name] = value
  })
  if (utm_attributes) {
    Object.keys(utm_attributes).forEach(function (key) {
      attribute_data[key] = utm_attributes[key]
    })
  }
  if (!Object.keys(attribute_data).length) return {}
  return { attributes: Object.assign({}, attribute_data) }
}
function getUTMAttributes() {
  // Retrieve UTMAttributes from Shopify cookie
  var shopifyCookieRegEx = /^_shopify_sa_p/
  var utmRegEx = /^utm_/
  var timestampRegEx = /^_shopify_sa_t/
  var utmParams = {}
  var shopifyCookie = ""
  var timestamp = ""
  document.cookie.split(";")
    .map(function (s) {
      return s.trim()
    })
    .forEach(function (s) {
      if (shopifyCookieRegEx.test(s)) {
        shopifyCookie = s
      }
      if (timestampRegEx.test(s)) {
        timestamp = decodeURIComponent(s.split("=")[1])
      }
      return
    })
  var utmValuesFromCookie = shopifyCookie.split("=")[1]
  decodeURIComponent(utmValuesFromCookie)
    .split("&")
    .forEach(function (s) {
      var key = s.split("=")[0]
      var val = s.split("=")[1]
      if (utmRegEx.test(key)) {
        return utmParams[key] = val
      }
      return
    })
  if (!Object.keys(utmParams).length) {
    return undefined
  }
  utmParams.utm_timestamp = timestamp
  utmParams.utm_data_source = "shopify_cookie"
  return utmParams
}
function getCartData(customer, options, cart) {
  // Return cart attributes and data
  return getCartJSON(options).then(function (cartDataJSON) {
    var cart_data = {},
      termsAndConditions = getTermsAndConditions(),
      notes = getNotes(cart),
      attributes = getAttributes(),
      cart_data = cartDataJSON,
      customer_data = buildCustomerObject(customer.email, customer.default_address);

    [termsAndConditions, notes, attributes, cart_data, customer_data].forEach(function (obj) {
      Object.assign(cart_data, obj)
    })

    return cart_data
  })
}
function buildInputs(form, obj) {
  // Build input fields for key, value pairs
  Object.keys(obj).forEach(function (key) {
    var input = document.createElement('input')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', key)
    input.setAttribute('value', typeof (obj[key]) === 'object' ? JSON.stringify(obj[key]) : obj[key])
    form.appendChild(input)
  })
}
function getSubmitButtons() {
  // Find all submit buttons
  var submit_selectors = [
    'form[action="/cart"] input[type="submit"]',
    '[name="checkout"]',
    '[href="/checkout"]',
    'form[action="/checkout"] input[type="submit"]',
    '.checkout_button',
  ],
    buttons = document.querySelectorAll(submit_selectors.join(',')),
    all_buttons = Array.prototype.slice.apply(buttons),
    submit_buttons = all_buttons.filter(function (elem) {
      // Don't watch update buttons
      return elem.name !== 'update'
    })
  return submit_buttons
}
function getOptions() {
  // Find all submit buttons
  var option_selectors = [
    '[name="updates[]"]'
  ],
    options = document.querySelectorAll(option_selectors.join(',')),
    options_to_update = Array.prototype.slice.apply(options)
  return options_to_update
}
function buildForm(data, url) {
  // Build a virtual form
  var form = document.createElement('form')
  form.setAttribute('method', 'post')
  form.setAttribute('action', url)
  form.setAttribute('id', 'rc_form')
  form.style.display = 'none'
  buildInputs(form, data)
  return form
}
function cartSubmit(options, customer, cart) {
  // Build and submit cart
  return getCartData(customer, options, cart).then(function (cart_data) {
    var checkout_url = buildCheckoutUrl(options)
    if (!cart_data) {
      window.location.href = checkout_url
      return
    }
    var xhr = new XMLHttpRequest()
    xhr.open('POST', '/cart/update.js')
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.onload = function () {
      if (xhr.status === 200) {
        window.console.log('done', JSON.parse(xhr.responseText))
      } else if (xhr.status !== 200) {
        window.console.log('fail', JSON.parse(xhr.responseText))
      }
      var form = buildForm(cart_data, checkout_url)
      document.body.appendChild(form)
      form.submit()
    }
    xhr.send(JSON.stringify(cart_data))
  })
}